import { createApp, h, reactive } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import PrimeVue from 'primevue/config';
import StyleClass from 'primevue/styleclass';
import Ripple from 'primevue/ripple';
import Tooltip from 'primevue/tooltip';
import ToastService from "primevue/toastservice";
import en from './Locales/en.json';
import id from './Locales/id.json';
import moment from 'moment';
import { createI18n } from 'vue-i18n';
import ErrorService from './Services/ErrorService';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const i18n = createI18n({
    locale: 'id',
    messages: {
        en: en,
        id: id,
    },
    fallbackLocale: 'en',
});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        const appNew = createApp({ render: () => h(app, props)})
        appNew.config.errorHandler = (error) => ErrorService.onError(error);
        appNew.config.globalProperties.$appState = reactive({ theme: 'lara-light-indigo', darkTheme: true });

        appNew.directive('styleclass', StyleClass)
        appNew.directive('ripple', Ripple)
        appNew.directive('tooltip', Tooltip)
        appNew.directive('moment', moment)
        appNew.use(plugin)
        appNew.use(PrimeVue, { ripple: true, inputStyle: 'outlined' })
        appNew.use(i18n)
        appNew.use(ToastService)
        appNew.mixin({ methods: { route } })
        appNew.mount(el)

        return appNew;
    },
});

InertiaProgress.init({ color: '#4B5563' });
